import { render, staticRenderFns } from "./tel.vue?vue&type=template&id=266586ea&scoped=true"
import script from "./tel.vue?vue&type=script&lang=js"
export * from "./tel.vue?vue&type=script&lang=js"
import style0 from "./tel.vue?vue&type=style&index=0&id=266586ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266586ea",
  null
  
)

export default component.exports